import './RunHistoryDots.css';

const STATUS_CLASS = {
  passed: 'rh-dot-passed',
  failed: 'rh-dot-failed',
  skipped: 'rh-dot-skipped',
  'in-progress': 'rh-dot-inprogress',
};

// `executions` is newest first; dots render oldest -> newest (left to right).
export default function RunHistoryDots({ executions, loading, error }) {
  if (loading) return <span className="rh-dots rh-loading" title="Loading execution history…" />;
  if (error) return <span title="Could not load execution history">⚠</span>;
  if (!executions?.length) return <span>—</span>;
  return (
    <span className="rh-dots">
      {[...executions].reverse().map((e, i) => (
        <span key={`${e.date}-${i}`} className={`rh-dot ${STATUS_CLASS[e.status] || 'rh-dot-skipped'}`}>
          <span className="rh-tip">
            <strong>{e.status}</strong>
            {new Date(e.date).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })}
          </span>
        </span>
      ))}
    </span>
  );
}
